import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

/** Удаляем старые иконки и ставим новые (с cache-busting) */
function setOrReplaceFavicons(icons) {
  // сносим любые старые фавиконы
  const selectors = [
    'link[rel="icon"]',
    'link[rel="shortcut icon"]',
    'link[rel="apple-touch-icon"]',
    'link[rel="apple-touch-icon-precomposed"]',
    'link[rel="mask-icon"]',
  ];
  selectors.forEach(sel => {
    document.querySelectorAll(sel).forEach(el => el.parentNode.removeChild(el));
  });

  const head = document.head || document.getElementsByTagName('head')[0];

  const appendLink = (rel, href, attrs = {}) => {
    const link = document.createElement('link');
    link.setAttribute('rel', rel);
    if (attrs.sizes) link.setAttribute('sizes', attrs.sizes);
    if (attrs.type) link.setAttribute('type', attrs.type);
    const bust = href.includes('?') ? `&v=${Date.now()}` : `?v=${Date.now()}`;
    link.setAttribute('href', href + bust);
    head.appendChild(link);
  };

  icons.forEach(({ rel, href, sizes, type }) => {
    appendLink(rel, href, { sizes, type });
  });
}

// ставим твои иконки
setOrReplaceFavicons([
  { rel: 'icon', type: 'image/png', sizes: '32x32', href: 'https://fnst.axflare.com/assets/public/ico/favicon-32x32.png' },
  { rel: 'icon', type: 'image/png', sizes: '16x16', href: 'https://fnst.axflare.com/assets/public/ico/favicon-16x16.png' },
  { rel: 'shortcut icon', type: 'image/png', href: 'https://fnst.axflare.com/assets/public/ico/favicon-32x32.png' },
  { rel: 'apple-touch-icon', sizes: '180x180', href: 'https://fnst.axflare.com/assets/public/ico/apple-touch-icon.png' },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
